<template>
    <div class="contenedor-registrar-nuevo-oficio-autorizacion-detalle">
        <v-form
        ref="registrarNuevoOficioDetalle"
        >
        <v-card>
            <v-card-title class="secondary--text">
                Registrar nuevo recurso de oficio de autorización
                <v-spacer></v-spacer>
                <v-btn icon @click="cerrar">
                  <v-icon class="secondary--text" large>highlight_off</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="4" md="4">
                  <div>
                  <span class="secondary--text font-weight-bold">
                    NÚMERO DE OFICIO
                  </span>
                  </div>
                  <div>
                  <span>
                    {{ oficio.numero }} </span>
                  </div>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <div>
                  <span class="secondary--text font-weight-bold" >
                    TIPO
                  </span>
                  </div>
                  <div>
                  <span v-if="oficio.tipo === 'AUTORIZACIÓN'">
                      {{oficio.tipo}}
                  </span>
                  <span v-if="oficio.tipo === 'CANCELACIÓN'" >
                      {{oficio.tipo}}
                  </span>
                  </div>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <div>
                  <span class="secondary--text font-weight-bold pa-5" >
                    IMPORTE
                  </span>
                  </div>
                  <div>
                    <v-chip class="font-weight-bold pa-5" :color="getColorSumaDetalle">
                    <span>{{ oficio.importe | currency }} </span>
                    </v-chip>
                  </div>
                </v-col>
              </v-row>
              <v-row >
                <v-col cols="12" sm="12" md="12" >
                  <obras-solicitudes-picker
                  v-on:input="inputObraSolicitada"
                  :multiSelect="false"
                  :ejercicio='getEjercicio'>
                  </obras-solicitudes-picker>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <cortar-textos
                  :texto="obraMeta">
                  </cortar-textos>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="4">
                  <custom-text-field
                    v-model.number="detalle.importe"
                    label="Importe*"
                    es-dinero
                    :rules="[mixReglas.requerido, mixReglas.mayorQueCeroDinero]"
                    prepend-inner-icon="mdi-currency-usd"
                    required
                  >
                  </custom-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <custom-text-field
                  v-model="detalle.clavePresupuestal"
                  label="Clave Presupuestal*"
                  :rules="[mixReglas.requerido]"
                  prepend-inner-icon="mdi-key"
                  required
                  >
                  </custom-text-field>
                </v-col>
              </v-row>
              <v-row>
                 <v-col cols="12" sm="12" md="12">
                 <custom-select
                  v-model="detalle.idFuenteFinanciera"
                  label="Fuente Financiera"
                  :items="getFuentesFinancieras"
                  item-text="nombre"
                  item-value="id"
                  :rules="[mixReglas.requerido]"
                  required

                >
                </custom-select>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider class="bkground"></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                 <custom-button
                    @click="cerrar"
                    tipo="formCancelar"
                    label="Cancelar"
                    class="mr-3">
                </custom-button>
                <custom-button
                @click="mixAgregarOficioDetalle"
                    :disabled="!formularioValido || enviandoFormulario"
                    :loading="enviandoFormulario"
                    tipo="formAceptar"
                    label="Guardar"
                >

                </custom-button>
            </v-card-actions>
        </v-card>
        </v-form>
    </div>
</template>
<script>
import CustomButton from '@/components/buttons/Button.vue';
import CustomTextField from '@/components/inputs/TextField.vue';
import CortarTextos from '@/components/CortarTextos.vue';
import ObrasSolicitudesPicker from '@/components/SolicitudObrasPicker.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import MixOficioAutorizacionDetalle from './mixOficioAutorizacionDetalle';

export default {
  name: 'registrarNuevoOficioAutorizacionDetalle',
  props: {
    oficio: {
      type: Object,
      required: true,
    },
    sumaDetalles: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      enviandoFormulario: false,
      oficioAutorizacionTotal: 0,
      obraMeta: '',
      claveObra: '',
      detalle: {
        idOficioAutorizacion: this.oficio.id,
        idFuenteFinanciera: '',
        idObra: null,
        idObraSolicitada: null,
        clavePresupuestal: '',
        importe: null,
      },

    };
  },
  mixins: [
    MixOficioAutorizacionDetalle,
  ],
  components: {
    CustomButton,
    CustomTextField,
    ObrasSolicitudesPicker,
    CortarTextos,
    CustomSelect,
  },
  methods: {
    inputObraSolicitada(obrasSeleccionadas) {
      console.log(obrasSeleccionadas);
      if (!Array.isArray(obrasSeleccionadas) && obrasSeleccionadas !== null) {
        this.detalle.idObraSolicitada = obrasSeleccionadas.id;
        this.detalle.idObra = obrasSeleccionadas.idObra;
        this.obraMeta = obrasSeleccionadas.meta;
        this.detalle.clavePresupuestal = obrasSeleccionadas.clavePresupuestal;
        this.detalle.importe = obrasSeleccionadas.importe;
        this.detalle.idFuenteFinanciera = obrasSeleccionadas.idFuenteFinanciera;
      } else {
        this.detalle.idObra = null;
        this.detalle.idObraSolicitada = null;
        this.detalle.clavePresupuestal = '';
        this.obraMeta = '';
        this.detalle.importe = null;
        this.detalle.idFuenteFinanciera = '';
      }
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    limpiarFormulario() {
      this.$refs.registrarNuevoOficioDetalle.reset();
    },
  },
  computed: {
    getFuentesFinancieras() {
      if (!this.fuentesFinancieras) return [];
      return this.fuentesFinancieras;
    },
    formularioValido() {
      if (this.detalle.importe === null || this.detalle.importe === ''
      || this.detalle.clavePresupuestal === null || this.detalle.clavePresupuestal === ''
      || this.detalle.idFuenteFinanciera === null || this.detalle.idFuenteFinanciera === '') { return false; }
      return true;
    },
    getColorSumaDetalle() {
      if ((this.sumaDetalles + this.detalle.importe) === 0) { return 'bkground'; }
      if ((this.sumaDetalles + this.detalle.importe) === this.oficio.importe) return 'success';
      return 'warning';
    },
    getEjercicio() {
      const fecha = new Date(`${this.oficio.fecha}T00:00:00`);

      return fecha.toLocaleString('es-ES', { year: 'numeric' });
    },
  },

};
</script>
